import { Button, Checkbox, Dropdown } from 'semantic-ui-react';
import { PAGE_MODE } from '../constants';
import { PageModeType } from '../types';

type PagesModeControlsPropsType = {
    pageMode: PageModeType;
    setPageMode: (mode: PageModeType) => void;
    className?: string;
    screenshotsEnabled: boolean;
    toggleScreenshotsEnabled: () => void;
};

const PagesModeControls = ({
    pageMode,
    setPageMode,
    className = '',
    screenshotsEnabled,
    toggleScreenshotsEnabled,
}: PagesModeControlsPropsType) => {
    return (
        <div className={`flex flex-align-center gap-10 ${className}`}>
            <Button>Mode</Button>
            <Dropdown
                selection
                onChange={(__, d) => setPageMode(d.value as PageModeType)}
                value={pageMode}
                options={Object.values(PAGE_MODE).map((v) => {
                    return { key: v, text: v, value: v };
                })}
            />
            <Checkbox
                toggle
                checked={screenshotsEnabled}
                onChange={toggleScreenshotsEnabled}
                label="Screenshots Enabled"
            />
        </div>
    );
};

export default PagesModeControls;
